import jwtDecode from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import { USER_STATES } from '../constants';
import { instanceRef } from '../utils/axios';

const UserContext = React.createContext({
  accessToken: '',
  grupos: []
});
const { Provider, Consumer } = UserContext;

const UserProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState();
  const [user, setUser] = useState();
  const [grupos, setGrupos] = useState([]);
  const [userState, setUserState] = useState();

  const updateUser = (userParam) => {
    localStorage.setItem('user', JSON.stringify(userParam));
    updateAuthInfo(userParam);
  };

  const updateAccessToken = (token) => {
    if (token !== accessToken) {
      setAccessToken(token);
    }
  };

  const logout = async () => {
    localStorage.removeItem('user');
    delete instanceRef.instance.defaults.headers.common.Authorization;
    removeAuthInfo();
  };

  const updateAuthInfo = (userParam) => {
    setUser(userParam);
    setUserState(USER_STATES.loggingEnd);
  };
  const removeAuthInfo = () => {
    setUser(undefined);
    setGrupos(undefined);
    setAccessToken(undefined);
  };

  const getGrupos = async () => {
    try {
      const response = await instanceRef.instance.get('auth/groups');
      if (response.data?.data) {
        const lista = response.data.data.Groups.map(
          ({ GroupName, Description }) => ({
            id: GroupName,
            descripcion: Description
          })
        );
        setGrupos(lista);
      }
    } catch (error) {
      // error
    }
  };

  useEffect(() => {
    const localUser = localStorage.getItem('user');
    if (localUser) {
      setUserState(USER_STATES.loggingStart);
      instanceRef.instance
        .post('auth/refresh')
        .then((responseToken) => {
          if (responseToken?.data?.data) {
            const {
              AuthenticationResult,
              usuarioSegu
            } = responseToken.data.data;
            const { AccessToken, IdToken } = AuthenticationResult;
            // eslint-disable-next-line no-param-reassign
            instanceRef.instance.defaults.headers.common.Authorization = `Bearer ${AccessToken}`;
            updateAccessToken(AccessToken);
            const usuario = jwtDecode(IdToken);
            usuario.usuarioSegu = usuarioSegu;
            updateUser(usuario);
            setUserState(USER_STATES.loggingEnd);
          }
        })
        .catch(() => {
          setUserState(USER_STATES.loggingEnd);
        });
    } else {
      setUserState(USER_STATES.notLogged);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (accessToken) {
      getGrupos();
    }
  }, [accessToken]);

  return (
    <Provider
      value={{
        accessToken,
        setAccessToken,
        updateAccessToken,
        user,
        updateUser,
        logout,
        updateAuthInfo,
        removeAuthInfo,
        grupos,
        userState
      }}
    >
      {children}
    </Provider>
  );
};

export default UserContext;
export { Consumer as UserConsumer, UserProvider };
